import { render, staticRenderFns } from "./appnode.vue?vue&type=template&id=5132f6ca&scoped=true&"
import script from "./appnode.vue?vue&type=script&lang=js&"
export * from "./appnode.vue?vue&type=script&lang=js&"
import style0 from "./appnode.vue?vue&type=style&index=0&id=5132f6ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132f6ca",
  null
  
)

export default component.exports